<template>
    <div>
        <!-- 对话框 -->
        <el-drawer title="发放优享券" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px" destroy-on-close>
            <!-- 基本信息表单 -->
            <div class="form-box priority">
                <template>
                    <el-form ref="form" :model="submit_data_send" label-width="130px" style="height: 90vh; overflow-y: auto">


                        <div>
                            <el-form-item>
                                <div>
                                    <el-button type="primary" style="margin-bottom: 10px" @click="download1">下载模板</el-button>


                                    <el-upload
                                        style="width: 350px; height: 200px; line-height: 20px"
                                        class="upload-demo"
                                        drag
                                        accept=".csv"
                                        :action="text_upload_url"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="text_headers"
                                        :data="submit_data_send"
                                        :on-success="getExcelData"
                                        multiple
                                    >
                                        <div class="el-upload__text upload">将文件拖到此处，或<em>点击上传</em></div>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                    <!-- 对话框底部按钮 -->
                    <div style="display: flex; justify-content: center">

                        <el-button @click="closeDialog">关闭</el-button>
                    </div>
                </template>
            </div>
        </el-drawer>
    </div>
</template>

<script>
var _this;
import { config } from '@/utils/config'; // 配置
//终端安装插件 npm install --save csv-exportor
// import {exportCsv} from '@/utils/utils.js';
import CsvExportor from 'csv-exportor'; //引入安装的插件

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

        }
    },
    data() {
        return {
              submit_data_send: {

            },

            phoneArray: [],

            downFileData: [{ top_store_name: '九州代驾', store_name: '门店名称', phone: '13366336688',tel: '13998989090', name: '张三', plate: '吉A879098' , equity_type_name: '免起步价', equity_num: '8'}], //csv 文件数据

            text_upload_url: config.axios_baseURL + '/store/importClientLists',
            // 上传文件的请求头
            text_headers: {
                'city-tag': '',
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'service-tag':''
            },


            excelData: [],

            priority_mode_code: '',

            show: false,

            submit_data_send: {

            },

        };
    },
    created() {
        _this = this;
    },

    methods: {


        // 下载模板方法
        download1() {
            let tableData = _this.downFileData;

            // let header = ['九州代驾', '长春门店', '13366336688','13998989090','李四','吉A879098','1','5'];
            let header = ['公司名称', '店铺名称', '员工手机号','客户电话','客户姓名','车牌号','权益类型','权益次数'];
            CsvExportor.downloadCsv(tableData, { header }, '上传.csv');
        },

        beforeAvatarUpload(file) {
            console.log(localStorage.getItem('city_tag'), 'localStorage.getItem');
            console.log(localStorage.getItem('access_token'), '============');
            // 添加请求头
            _this.text_headers['city-tag'] = localStorage.getItem('city_tag');
            _this.text_headers['service-tag'] = localStorage.getItem('service_tag');
            _this.text_headers.token = localStorage.getItem('access_token');
            _this.text_headers['hash-key'] = _this.$hash_key();
            
        },

        getExcelData(response) {
            if (response.data.length == 0) {
                this.$message.success('批量操作全部成功！');
                _this.$emit('onSubmit');
                _this.closeDialog();
                return;
            }
            this.$message.error('符合条件数据已导入，异常数据见excel表格！');

            if (this.$route.path == '/storeClientList') {
                // 导出excel的空数组中添加数据
                for (let i = 0; i < response.data.length; i++) {
                    // 向excelData数组里添加
                    _this.excelData.push({
                        top_store_name: response.data[i][0],
                        store_name: response.data[i][1],
                        phone: response.data[i][2],
                        tel: response.data[i][3],
                        name: response.data[i][4],
                        plate: response.data[i][5],
                        equity_type_name: response.data[i][6],
                        equity_num: response.data[i][7],
                        remark: response.data[i][8],
                    });
                }

                // 将数据导出excel
                _this.exportData();
                console.log(_this.excelData, '_this.excelData');

                // 清空数据
                _this.excelData = [];
            }
        },
        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['公司名称', '店铺名称', '员工手机号','客户电话','客户姓名','车牌号','权益类型','权益次数', '失败原因'];
            const filterVal = ['top_store_name', 'store_name', 'phone', 'tel','name', 'plate', 'equity_type_name', 'equity_num','remark'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '导入失败数据');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;


        },

    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
<style>
.priority .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
    margin-top: 10px;
}

</style>